import BodyColumnData from "@/components/body/BodyColumnData";
import BodyContainer from "@/components/body/BodyContainer";
import BodyValues from "@/components/body/BodyValues";
import Labs from "@/components/body/Labs";
import PatientDetailBody from "@/components/body/PatientDetailBody";
import Popups from "@/components/popups/";
import Alerts from "@/components/shared/Alerts";
import SparkLine from "@/components/shared/chart/SparkLine";
import BodySharedMinData from "@/mixins/BodySharedMinData";
import GraphRanges from "@/mixins/GraphRanges";
import Layout from "@/mixins/Layout";
import { navigationNamespace } from "@/store/modules/navigation";
import { patientNamespace } from "@/store/modules/patient";
import { Patient } from "@/store/modules/patient/types";
import { Component, Mixins } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";

@Component({
  components: {
    PatientDetailBody,
    Alerts,
    BodyContainer,
    BodyValues,
    Labs,
    SparkLine,
    BodyColumnData,
    ...Popups
  }
})
export default class DesktopMin extends Mixins(
  BodySharedMinData,
  Layout,
  GraphRanges
) {
  @Action("showPopup", navigationNamespace)
  showPopup!: Function;

  // TODO: Pass this
  @Getter("current", patientNamespace)
  patient!: Patient;

  @Getter("area", patientNamespace)
  area!: string;

  @Getter("darkMode", navigationNamespace)
  dark!: boolean;

  @Getter("vars", patientNamespace)
  vars!: any;

  @Getter("config", patientNamespace)
  config!: any;

  popupOverride() {
    this.showPopup("ChartSummary");
  }
}
